<template>
  <b-row>
    <b-col md="6">
      <seller-registration-card/>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import SellerRegistrationCard from '@/components/seller-registration/SellerRegistrationCard';

export default {
  mixins: [BaseComponent],
};

Vue.component('seller-registration-card', SellerRegistrationCard);
</script>
